<button class="mc-ar__button"
				[class]="{ modal: !isProd }"
				(click)="onOpenAr()"
				[disabled]="isProd && !isModelLoaded || isButtonClicked">
	{{ 'augmented_reality.ar' | translate }}
</button>
